import { reactive } from 'vue';

/**
 * 财税实战课堂 V0.3 原型（教师端）共享状态。
 * 数据与交互逻辑自交互原型 index.html 原样迁移，全部为示例数据，不请求外部接口。
 */

// ===== 问题与投票话题 =====
// reactive：需求管理页保存的问题/说明需同步到问题墙等页面
export const topics = reactive([
  { id: 'all', label: '全部问题', group: '一起看见真实需求', prompt: '这节课，你最想解决什么问题？' },
  { id: 'lesson', label: '这节课最想解决什么问题？', group: '本节课 · 真实需求', prompt: '这节课，你最想解决什么问题？' },
  { id: 'work', label: '工作中，你正面临什么问题？', group: '工作现场 · 真问题', prompt: '工作中，哪件事正让你感到棘手？' },
  { id: 'enterprise', label: '企业财务管理最大的卡点？', group: '企业现场 · 财务管理', prompt: '走进企业做财务管理，你遇到的最大卡点是什么？' },
  { id: 'ai', label: '最想用 AI 解决什么问题？', group: 'AI 实战 · 应用需求', prompt: '你最想用 AI 解决的具体工作问题是什么？' },
  { id: 'vote', label: '最想优先突破哪个方向？', group: '现场投票 · 选出重点', prompt: '你目前最想优先突破哪个方向？' },
  { id: 'next', label: '这三天，你还想学什么？', group: '三天学习 · 期待补充', prompt: '接下来的三天，你还想带走哪些方法和成果？' },
  { id: 'class', label: '对这堂课，有什么建议？', group: '课堂建议 · 及时反馈', prompt: '怎样调整课堂，会更有助于你学会并用起来？' },
  { id: 'course', label: '希望课程增加哪些内容？', group: '课程建议 · 持续改进', prompt: '为了更好地解决企业问题，你希望课程增加什么内容？' }
]);
export const topic = id => topics.find(t => t.id === id) || topics[1];

// ===== 学员问题墙数据 =====
export const posts = reactive([
  { id: 'p1', uid: 's1', author: '王敏', role: '财务经理', industry: '制造业', topic: 'lesson', title: '费用分析做了很多，怎样让业务部门真正采取行动？', body: '我们每月都有部门费用分析表，但汇报后，业务负责人往往只看总额，很少继续落实改进。\n\n现在卡在：财务知道费用超了，却很难把原因讲清楚，更难把责任和行动对应到具体岗位。\n\n我希望这节课能学会从差异分析走到行动建议，最好能有一份可以直接练习的 Excel 和沟通案例。', goal: '形成可执行的经营建议', resonance: 6, replies: [{ id: 'r1', author: '李老师', kind: 'teacher', body: '这个问题会放到今天的案例里。我们先用费用审批职责清单，把“差异—原因—责任人—动作”串起来，再练习怎样与业务沟通。', target: '' }, { id: 'r2', author: '赵磊', kind: 'student', body: '我们也遇到过。先和业务一起确认差异原因，再让负责人写下一项能执行的动作，会比只发报表更容易推进。', target: '王敏' }] },
  { id: 'p2', uid: 's2', author: '赵磊', role: '财务主管', industry: '商贸业', topic: 'work', title: '回款周期越来越长，怎么用现有数据找到最需要跟进的客户？', body: '目前每周手工合并应收台账，销售、财务使用的客户名称还不统一。希望能先整理出可靠的账龄，再形成每周的回款跟进清单。', goal: '建立回款跟进清单', resonance: 3, replies: [] },
  { id: 'p3', uid: 's3', author: '刘佳', role: '财务经理', industry: '制造业', topic: 'enterprise', title: '预算总是财务自己编，怎样让业务负责人愿意一起做？', body: '企业有年度预算，但业务部门觉得这只是财务的表格。编制时参与不多，执行时也缺少复盘。最大的卡点是部门目标没有和预算动作对应起来。', goal: '推动业务参与预算', resonance: 5, replies: [{ id: 'r3', author: '周老师', kind: 'teacher', body: '先把部门目标和关键业务动作拆出来，再讨论需要哪些资源。预算模板可以帮助表达，但要从业务目标开始。', target: '' }] },
  { id: 'p4', uid: 's4', author: '周宁', role: '财务主管', industry: '服务业', topic: 'ai', title: '每月要合并十几张 Excel，想用 AI 减少重复整理。', body: '不同部门交来的表头、日期和分类不一致，每月整理占用很多时间。希望学会先把数据标准化，再用 AI 辅助合并和发现异常。', goal: '减少数据整理时间', resonance: 7, replies: [{ id: 'r4', author: '林悦', kind: 'student', body: '我们也想学这个，尤其是先统一字段和分类的步骤。', target: '周宁' }] },
  { id: 'p5', uid: 's5', author: '林悦', role: '经营管理者', industry: '零售业', topic: 'next', title: '这三天还想练习现金流预测，能不能安排一个完整案例？', body: '希望把销售、回款、采购付款联系起来，做一个未来几周的现金流预测，最后能带走一份自己的练习成果。', goal: '完成现金流预测练习', resonance: 6, replies: [] },
  { id: 'p6', uid: 's6', author: '张玲', role: '财务主管', industry: '服务业', topic: 'class', title: '希望老师演示 Excel 时，可以边看课件边跟着操作。', body: '有些操作讲得很快，想在课程资料里随时找到同一版本的文件，回去后还能继续练习。', goal: '课上跟练课后复习', resonance: 5, replies: [] },
  { id: 'p7', uid: 's7', author: '许航', role: '财务经理', industry: '制造业', topic: 'course', title: '希望增加走进企业后如何做第一次财务管理诊断的案例。', body: '想知道第一次访谈老板和业务负责人应该问什么、看哪些数据，以及怎样判断先从哪里切入。', goal: '掌握企业诊断切入方法', resonance: 6, replies: [] },
  { id: 'p8', uid: 's8', author: '宋洁', role: '财务主管', industry: '商贸业', topic: 'work', title: '经营报表口径经常变，如何和业务统一指标定义？', body: '同一项收入，业务按订单、财务按确认时间，各自的报表难以比较。希望能建立一份双方认可的指标口径清单。', goal: '统一经营指标口径', resonance: 4, replies: [] }
]);
export const voteOptions = ['经营分析与财务 BP', '全面预算落地', '企业财税风险管理', 'AI 数据分析', '内控与流程改善'];
export const votes = reactive(new Map([['s1', 0], ['s2', 1], ['s3', 1], ['s4', 3], ['s5', 0], ['s6', 3], ['s7', 2], ['s8', 4]]));
export const liked = reactive(new Set());

// ===== 课程资料 =====
export const files = [
  { id: 'excel', name: '费用审批职责清单.xlsx', kind: 'XLSX', chapter: '2', desc: '第 2 讲 · 课堂跟练 · 含填写说明' },
  { id: 'slides', name: '费用流程与经营协同课件.pdf', kind: '课件', chapter: '2', desc: '第 2 讲 · 老师授课演示' },
  { id: 'workbook', name: '企业业务流程访谈表.xlsx', kind: 'XLSX', chapter: '1', desc: '第 1 讲 · 场景访谈与资料准备' },
  { id: 'action', name: '经营分析行动建议练习.pdf', kind: 'PDF', chapter: '3', desc: '第 3 讲 · 分析到行动的练习' }
];

// ===== 任务/作业/测试/评分公共数据 =====
export const lessonNames = ['理解企业业务', '费用流程与经营协同', '分析与行动建议', '预算与业务目标', '经营数据口径', '责任岗位与协作', '业务访谈与诊断', '财务分析表达', '风险识别与跟进', '跨部门沟通', '成果复盘', '综合实战'];
export const rubric = [['成果完整性', 20], ['业务与数据准确性', 30], ['分析思路', 30], ['应用与表达', 20]];
export const quizBank = [
  { title: '费用分析完成后，怎样让结论更容易被业务部门执行？', options: ['只发送费用明细表', '明确行动、责任岗位与复盘时间', '只增加更多图表'], answer: 1, analysis: '分析应形成可以跟进的行动建议，明确由谁负责、何时复盘。', source: '第 2 讲课件 · 从分析到行动' },
  { title: '不同部门对同一个经营指标理解不一致，第一步应怎样处理？', options: ['先统一指标定义、范围和数据来源', '直接比较结果并排名', '由财务独自决定所有业务动作'], answer: 0, analysis: '先统一数据口径，再讨论差异与行动，避免用不同定义得出结论。', source: '第 2 讲职责清单 · 数据口径' },
  { title: '开展费用差异分析时，哪种信息更有助于定位业务原因？', options: ['只有费用总额', '只有上月同比', '费用变化对应的业务量、单价和具体场景'], answer: 2, analysis: '把财务变化与业务场景关联，才能进一步核实差异原因。', source: '第 2 讲课件 · 差异分析练习' }
];
export const clone = v => JSON.parse(JSON.stringify(v));
export const sampleFiles = {
  xlsx: { name: '费用差异分析与行动清单.xlsx', kind: 'xlsx', size: '48 KB', sample: true, status: 'ready' },
  pptx: { name: '经营分析沟通汇报.pptx', kind: 'pptx', size: '1.2 MB', sample: true, status: 'ready' },
  docx: { name: '业务访谈与改进建议.docx', kind: 'docx', size: '36 KB', sample: true, status: 'ready' }
};

// ===== 页面级状态（对应原型 st） =====
export const st = reactive({
  topic: 'all', sort: 'latest', selected: 'p1', classOpen: true, role: 'teacher', detailFrom: 'teacher',
  province: '湖北省', scheduleType: 'all', replyTo: '', file: 'excel', fileFilter: 'all', voted: false
});

// 自增 id（对应原型 newId，从 20 起：新问题 new20、新回复 r20…）
let newId = 20;
export function nextId() {
  return newId++;
}

// ===== toast（原型底部提示条，切换页面时隐藏） =====
export const toastState = reactive({ text: '', visible: false });
export function showToast(s) {
  toastState.text = s;
  toastState.visible = true;
}
export function hideToast() {
  toastState.visible = false;
}

// ===== 任务 / 作业 / 测试 / 批阅 / CRM 同步（对应原型 edu） =====
export const edu = reactive({
  lesson: 'all', filter: 'all', currentTask: 'a1', assignmentOpen: true, quizOpen: true, grading: 'wang',
  tasks: [
    { id: 'a1', kind: 'practice', lesson: 2, title: '把费用差异变成业务行动建议', brief: '结合一个已脱敏的企业场景，比较计划与实际费用，说明主要差异及业务原因。\n请提交费用分析 Excel，并用文字说明 3 项改进行动、责任岗位与复盘时间；也可附上汇报 PPT 或建议 Word。', max: 100, due: '2026-10-21 18:00' },
    { id: 'a2', kind: 'practice', lesson: 3, title: '完成一份企业业务访谈与诊断建议', brief: '围绕工作中的一个真实协同卡点，整理访谈对象、问题、证据和行动建议。\n请提交脱敏后的 Word 访谈记录或 PPT 诊断方案，并说明最希望老师点评的部分。', max: 100, due: '2026-10-22 18:00' },
    { id: 'q1', kind: 'quiz', lesson: 2, title: '费用流程与经营协同课堂测试', due: '2026-10-21 18:00' }
  ],
  answers: {}, questions: clone(quizBank), quizVersion: 1, quizAnswers: {}, quizResult: null, quizPending: false, quizAttempts: [],
  builder: [], builderKind: 'quiz', builderDirty: false, builderReviewed: false, builderStateText: '待老师审核', builderStatus: '',
  scores: [
    { id: 'past-a', student: '陈晨', title: '企业业务链梳理作业', kind: 'practice', score: 92, max: 100, version: 1, submission: 1, feedback: '业务链条完整，建议补充关键岗位之间的信息交接方式。', state: 'success' },
    { id: 'past-q', student: '陈晨', title: '第 1 讲基础应用测试', kind: 'quiz', score: 20, max: 30, version: 1, submission: 1, feedback: '已按老师审核的答案自动计分，可回看本次解析。', state: 'failed' }
  ],
  logs: [
    '10:23 · 第 1 讲测试成绩 20 / 30 已保存；CRM 接收超时，等待补发。',
    '10:21 · 业务链梳理作业 92 / 100 已同步，示例回执 CRM-DEMO-101。'
  ],
  teacher: {
    wang: {
      student: '王敏', task: 'a1', text: '我选择了已脱敏的商贸企业费用场景。差异主要来自活动频次和投放单价变化，已在 Excel 中列出 3 项行动建议，并在 PPT 中补充沟通顺序。希望老师重点看看业务原因是否说清楚。',
      files: [clone(sampleFiles.xlsx), clone(sampleFiles.pptx)], submission: 1, values: [18, 26, 25, 17],
      feedback: '分析比较清楚。请补充每项行动的责任岗位与复盘时间，让成果更容易用于沟通。', history: [], grade: null
    }
  },
  gradeStatus: ''
});

// ===== 出题与发布表单 =====
export const builderForm = reactive({
  kind: 'quiz', lesson: 2, count: 3, difficulty: '基础应用',
  source: '第 2 讲课件与职责清单', target: '费用差异、责任岗位与业务行动建议', deadline: '2026-10-21T18:00'
});

export function taskFor(id = edu.currentTask) {
  return edu.tasks.find(t => t.id === id) || edu.tasks[0];
}
export function answerFor(id = edu.currentTask) {
  if (!edu.answers[id]) edu.answers[id] = { text: '', files: [], versions: [], saved: false };
  return edu.answers[id];
}
export function lastSubmission(id = edu.currentTask) {
  const a = edu.answers[id];
  return a ? a.versions[a.versions.length - 1] : undefined;
}
export function participants() {
  return new Set([...posts.map(p => p.uid), ...votes.keys()]).size;
}
export function isWritable() {
  return st.classOpen || st.role === 'teacher';
}

// ===== 课堂互动开关（真实需求页） =====
export function toggleClassOpen() {
  st.classOpen = !st.classOpen;
  showToast(st.classOpen ? '示例课堂互动已重新开放。' : '示例课堂已结束：学员只读，老师仍可回复课堂已有问题。');
}
export function setTopic(id) {
  st.topic = id;
}

// ===== 需求管理（需求配置）：主题与提问配置，保存后同步到问题墙 =====
const TOPIC_SEED = clone(topics); // 初始化用原始话题副本
// 各主题回答形式：qa 问答 / radio 单选 / multi 多选
export const needConfig = reactive({});
function defaultNeed(id) {
  if (id === 'vote') return { kind: 'radio', count: voteOptions.length, options: [...voteOptions] };
  return { kind: 'qa', count: 2, options: ['', ''] };
}
export function needFormOf(id) {
  if (!needConfig[id]) needConfig[id] = defaultNeed(id);
  return needConfig[id];
}
export function needSaveTopic(id, form) {
  const t = topic(id);
  if (t) {
    t.label = form.title;
    t.prompt = form.desc;
  }
  needConfig[id] = { kind: form.kind, count: form.count, options: [...form.options] };
}
export function needAddTopic(name) {
  const id = 't' + nextId();
  // 新增仅登记主题名，问题与说明留空，由老师在表单填写后保存
  topics.push({ id, label: '', group: name, prompt: '' });
  needConfig[id] = defaultNeed(id);
  return id;
}
export function needRemoveTopic(id) {
  if (posts.some(p => p.topic === id)) return false; // 主题下已有学员问题，禁止删除
  const i = topics.findIndex(t => t.id === id);
  if (i > -1) topics.splice(i, 1);
  delete needConfig[id];
  return true;
}
export function needInit() {
  topics.splice(0, topics.length, ...clone(TOPIC_SEED));
  Object.keys(needConfig).forEach(k => delete needConfig[k]);
}

// ===== 出题与发布 =====
export function buildQuestions(quiet = false) {
  const raw = Number(builderForm.count);
  if (!Number.isInteger(raw) || raw < 1) {
    edu.builderStatus = '题量请填写大于 0 的整数。';
    return;
  }
  const count = Math.min(raw, 50);
  builderForm.count = count;
  edu.builderKind = builderForm.kind;
  edu.builderDirty = false;
  const target = String(builderForm.target).trim() || '分析与行动建议';
  edu.builder = Array.from({ length: count }, (_, i) => edu.builderKind === 'quiz'
    ? { ...clone(quizBank[i % 3]), title: (i >= 3 ? '情境 ' + (i + 1) + '：' : '') + quizBank[i % 3].title, source: builderForm.source + ' · 教学示例' }
    : { title: '实战任务 ' + (i + 1) + '：' + target, brief: '结合已脱敏企业场景完成分析，提交文字说明与 Excel、PPT 或 Word 成果。', analysis: '按完整性、业务与数据准确性、分析思路、应用与表达评分。', source: builderForm.source });
  edu.builderStatus = raw > 50 ? '为便于原型体验，本次展示前 50 道草稿；这是演示容量，不是产品题量限制。' : (quiet ? '' : '已生成 ' + count + ' 道示例草稿，请逐题核对并审核。');
}
export function resetBuilderReview() {
  edu.builderStateText = '待老师审核';
  edu.builderReviewed = false;
}
export function builderReset() {
  edu.builderDirty = true;
  edu.builderReviewed = false;
  edu.builderStateText = '配置已变更 · 请重新生成';
  edu.builderStatus = '重新生成草稿后再审核发布。';
}
export function markBuilderEdited() {
  edu.builderReviewed = false;
  edu.builderStateText = '修改后需重新审核';
}
export function publishQuestions() {
  if (edu.builderDirty) { edu.builderStatus = '配置已改变，请先重新生成草稿。'; return; }
  if (!edu.builderReviewed) { edu.builderStatus = '请先检查题目、参考答案、解析与出处，并勾选审核确认。'; return; }
  if (edu.builder.some(q => !q.title.trim() || !q.analysis.trim() || (q.options && q.options.some(o => !o.trim())))) {
    edu.builderStatus = '请补全题干、选项和解析后发布。';
    return;
  }
  if (!builderForm.deadline) { edu.builderStatus = '请设置提交截止时间。'; return; }
  const lesson = Number(builderForm.lesson);
  const due = String(builderForm.deadline).replace('T', ' ');
  if (edu.builderKind === 'quiz') {
    edu.questions = clone(edu.builder);
    edu.quizVersion++;
    edu.quizAnswers = {};
    edu.quizResult = null;
    edu.quizPending = false;
    const task = taskFor('q1');
    task.lesson = lesson;
    task.due = due;
  } else {
    const base = edu.tasks.length;
    edu.builder.forEach((q, i) => edu.tasks.push({ id: 'new-' + (base + i), kind: 'practice', lesson, title: q.title, brief: q.brief + '\n' + q.analysis, max: 100, due }));
  }
  edu.builderStateText = '已审核发布';
  edu.builderStatus = '已向本班发布 ' + edu.builder.length + ' 道' + (edu.builderKind === 'quiz' ? '测试题，历史作答与成绩按原版本保留。' : '实战作业，可在学习任务中查看。');
  showToast('示例题目已发布，可切换到“学习任务”查看学员页面。');
}
export function toggleAssignmentWindow() {
  edu.assignmentOpen = !edu.assignmentOpen;
  showToast(edu.assignmentOpen ? '作业提交已开放，课堂提问开关保持原状态。' : '作业提交已关闭，历史作业和反馈仍可查看。');
}

// ===== 作业批阅 =====
export function gradingEntity() {
  if (edu.grading === 'wang') return edu.teacher.wang;
  const id = edu.grading.slice(5);
  const v = lastSubmission(id);
  if (!v) return edu.teacher.wang;
  const key = edu.grading + '-' + v.version;
  if (!edu.teacher[key]) {
    edu.teacher[key] = {
      student: '陈晨', task: id, text: v.text, files: clone(v.files), submission: v.version, values: [18, 26, 25, 17],
      feedback: '分析比较清楚。请补充每项行动的责任岗位与复盘时间，让成果更容易用于沟通。', history: [],
      grade: edu.scores.find(g => g.id === key) || null
    };
  }
  return edu.teacher[key];
}
export function publishGrade(reason) {
  const e = gradingEntity();
  if (e.values.some((v, i) => !Number.isInteger(v) || v < 0 || v > rubric[i][1])) {
    edu.gradeStatus = '各评分项请填写范围内的整数分数。';
    return false;
  }
  const feedback = (e.feedback || '').trim();
  if (!feedback) {
    edu.gradeStatus = '请填写具体点评与改进建议。';
    return false;
  }
  if (e.grade && !reason) {
    edu.gradeStatus = '更正已发布成绩时，请填写更正原因。';
    return false;
  }
  const id = e.student === '王敏' ? 'wang-a1-1' : 'chen-' + e.task + '-' + e.submission;
  const old = e.grade;
  const version = (old?.version || 0) + 1;
  if (old) old.superseded = true;
  const grade = {
    id, student: e.student, task: e.task, title: taskFor(e.task).title, kind: 'practice',
    score: e.values.reduce((s, v) => s + v, 0), max: 100, version, submission: e.submission,
    feedback, reason, state: 'pending'
  };
  edu.scores.unshift(grade);
  e.grade = grade;
  e.history.push(clone(grade));
  e.feedback = feedback;
  edu.logs.unshift('本次演示 · ' + e.student + ' ' + (old ? '成绩更正' : '正式成绩发布') + ' V' + version + '：' + grade.score + ' / 100' + (reason ? '；原因：' + reason : '') + '，等待 CRM 同步。');
  edu.gradeStatus = '正式成绩 V' + version + ' 已发布，已进入 CRM 同步队列（演示）。';
  return true;
}

// ===== CRM 成绩同步 =====
export function syncGrade(id, version) {
  const g = edu.scores.find(g => g.id === id && g.version === version && !g.superseded);
  if (!g) {
    showToast('此成绩已有更新版本，请刷新队列查看最新成绩。');
    return;
  }
  if (g.state === 'success') return;
  g.state = 'success';
  edu.logs.unshift('本次演示 · ' + g.student + ' 成绩 V' + g.version + ' ' + g.score + ' / ' + g.max + ' 同步成功，示例回执 CRM-DEMO-' + (110 + edu.logs.length) + '；按同一成绩版本更新，未重复建档。');
}

// ===== 页面 id → 路由映射 =====
export const PAGE_ROUTES = {
  teacher: '/practicalClass/real-needs',
  needs: '/practicalClass/need-manage',
  builder: '/practicalClass/question-publish',
  grading: '/practicalClass/homework-review',
  resources: '/practicalClass/course-materials',
  sync: '/practicalClass/crm-sync',
  wall: '/practicalClass/question-wall',
  detail: '/practicalClass/question-detail'
};
export const ROUTE_PAGES = Object.fromEntries(Object.entries(PAGE_ROUTES).map(([k, v]) => [v, k]));

// 初始化：与原型一致，进入时先生成一份题目草稿
buildQuestions(true);
